"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var abstract_input_store_1 = require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store");
var map_name_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/designated/map_name_input"));
var input_store_factory_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/input_store_factory"));
var MapNameInputStore = /** @class */ (function () {
    function MapNameInputStore(props) {
        var _this = this;
        this.component = map_name_input_1.default;
        this.inputStore = input_store_factory_1.default.createInputStore(props.inputProps);
        (0, mobx_1.reaction)(function () { return _this.inputStore.value; }, props.onChange);
    }
    Object.defineProperty(MapNameInputStore.prototype, "name", {
        get: function () {
            return this.inputStore.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapNameInputStore.prototype, "value", {
        get: function () {
            return this.inputStore.value;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof abstract_input_store_1.IInputStore !== "undefined" && abstract_input_store_1.IInputStore) === "function" ? _a : Object)
    ], MapNameInputStore.prototype, "inputStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], MapNameInputStore.prototype, "name", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], MapNameInputStore.prototype, "value", null);
    return MapNameInputStore;
}());
exports.default = MapNameInputStore;
